<script>
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";

export default {
  props: {
    show: Boolean,
    data: Object,
    idWorkOrder: {
      type: [String, Number],
      default: null,
    },
    mode: {
      type: String,
      default: "add",
    },
  },

  data() {
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      isLoading: false,

      form: {
        id_work_order_detail: null,
        id_work_order: null,
        idpegawai_internal: null,
        id_mprofesi: null,
        id_target_kompetensi: null,
        id_target_peg: null,
        id_jenjang_jabatan: null,
        idlevel_kompetensi: null,
      },

      selected: {
        pegawaiInternal: null,
        profesi: null,
        targetKompetensi: null,
        targetPeg: null,
        jenjangJabatan: null,
        levelKompetensi: null,
      },

      optionPegawaiInternal: [],
      optionProfesi: [],
      optionTargetKompetensi: [],
      optionTargetPeg: [],
      optionJenjangJabatan: [],
      optionLevelKompetensi: [],
    };
  },

  watch: {
    modalShow(val) {
      if (val) {
        if (this.mode === "edit" && this.data) {
          this.form = {
            id_work_order_detail: this.data.id_work_order_detail,
            id_work_order: this.data.id_work_order,
            idpegawai_internal: this.data.idpegawai_internal,
            id_mprofesi: this.data.id_mprofesi,
            id_target_kompetensi: this.data.id_target_kompetensi,
            id_target_peg: this.data.id_target_peg,
            id_jenjang_jabatan: this.data.id_jenjang_jabatan,
            idlevel_kompetensi: this.data.idlevel_kompetensi,
          };

          this.selected = {
            pegawaiInternal: this.data.pegawai_internal ?? null,
            profesi: this.data.mprofesi ?? null,
            targetKompetensi: this.data.target_kompetensi ?? null,
            targetPeg: this.data.target_peg ?? null,
            jenjangJabatan: this.data.jenjang_jabatan ?? null,
            levelKompetensi: this.data.level_kompetensi ?? null,
          };

          this.ensureOptionSelected(this.optionPegawaiInternal, this.selected.pegawaiInternal, "idpegawai_internal");
          this.ensureOptionSelected(this.optionProfesi, this.selected.profesi, "id_mprofesi");
          this.ensureOptionSelected(this.optionTargetKompetensi, this.selected.targetKompetensi, "id_target_kompetensi");
          this.ensureOptionSelected(this.optionTargetPeg, this.selected.targetPeg, "id_target_peg");
          this.ensureOptionSelected(this.optionJenjangJabatan, this.selected.jenjangJabatan, "id_jenjang_jabatan");
          this.ensureOptionSelected(this.optionLevelKompetensi, this.selected.levelKompetensi, "idlevel_kompetensi");
        } else {
          this.resetForm();
        }
      } else {
        this.resetForm();
      }
    },

    "selected.pegawaiInternal"(val) {
      this.form.idpegawai_internal = val?.idpegawai_internal ?? null;
    },
    "selected.profesi"(val) {
      this.form.id_mprofesi = val?.id_mprofesi ?? null;
    },
    "selected.targetKompetensi"(val) {
      this.form.id_target_kompetensi = val?.id_target_kompetensi ?? null;
    },
    "selected.targetPeg"(val) {
      this.form.id_target_peg = val?.id_target_peg ?? null;
    },
    "selected.jenjangJabatan"(val) {
      this.form.id_jenjang_jabatan = val?.id_jenjang_jabatan ?? null;
    },
    "selected.levelKompetensi"(val) {
      this.form.idlevel_kompetensi = val?.idlevel_kompetensi ?? null;
    },
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },

  created() {
    // debounce supaya request pencarian tidak dikirim setiap ketikan.
    // hanya Pegawai Internal yang dicari ke server (datanya bisa ribuan);
    // data master lainnya dimuat sekali lalu difilter di client oleh v-select.
    this.searchPegawaiInternal = _.debounce(this.onSearchPegawaiInternal, 400);
  },

  mounted() {
    // ambil data awal untuk semua pilihan pada saat modal pertama kali dipakai
    this.getPegawaiInternal();
    this.getProfesi();
    this.getTargetKompetensi();
    this.getTargetPeg();
    this.getJenjangJabatan();
    this.getLevelKompetensi();
  },

  methods: {
    ensureOptionSelected(options, selectedOption, idField) {
      if (!selectedOption) return;
      const exists = options.some((opt) => opt[idField] === selectedOption[idField]);
      if (!exists) options.unshift(selectedOption);
    },

    onSearchPegawaiInternal(search, loading) {
      loading(true);
      this.getPegawaiInternal(search, loading);
    },

    getPegawaiInternal(search = "", loading = () => {}) {
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master/pegawai-internal/search",
        params: { 
          search: search,
          is_get_all: false,
          limit: 50
        },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionPegawaiInternal = res.data?.data ?? [];
          loading(false);
        })
        .catch((err) => {
          console.log(err);
          loading(false);
        });
    },

    getProfesi() {
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master/profesi",
        params: { per_page: 200, column: "nama_profesi", dir: "desc", filter_status: 'ENABLE' },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionProfesi = res.data?.data?.data ?? [];
        })
        .catch((err) => console.log(err));
    },

    getTargetKompetensi() {
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master-asesmen/target-kompetensi",
        params: { per_page: 200, column: "target_kompetensi", dir: "asc" },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionTargetKompetensi = res.data?.data?.data ?? [];
        })
        .catch((err) => console.log(err));
    },

    getTargetPeg() {
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master-asesmen/target-peg",
        params: { per_page: 200, column: "target_peg", dir: "asc" },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionTargetPeg = res.data?.data?.data ?? [];
        })
        .catch((err) => console.log(err));
    },

    getJenjangJabatan() {
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "master-asesmen/jenjang-jabatan",
        params: { per_page: 200, column: "nama_jenjang", dir: "asc" },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionJenjangJabatan = res.data?.data?.data ?? [];
        })
        .catch((err) => console.log(err));
    },

    getLevelKompetensi() {
      axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "verifikasi/level-kompetensi",
        params: { per_page: 200, column: "nama_level", dir: "asc" },
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          this.optionLevelKompetensi = res.data?.data?.data ?? [];
        })
        .catch((err) => console.log(err));
    },

    resetForm() {
      this.form = {
        id_work_order_detail: null,
        id_work_order: this.idWorkOrder ?? null,
        idpegawai_internal: null,
        id_mprofesi: null,
        id_target_kompetensi: null,
        id_target_peg: null,
        id_jenjang_jabatan: null,
        idlevel_kompetensi: null,
      };
      this.selected = {
        pegawaiInternal: null,
        profesi: null,
        targetKompetensi: null,
        targetPeg: null,
        jenjangJabatan: null,
        levelKompetensi: null,
      };
    },

    store() {
      if (this.isLoading) return;

      if (!this.form.idpegawai_internal) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "Pegawai Internal tidak boleh kosong.",
          showConfirmButton: true,
        });
        return;
      }

      const url =
        this.mode === "edit"
          ? this.BACKEND_URL_VERSION +
            "work-order/detail/" +
            this.form.id_work_order_detail
          : this.BACKEND_URL_VERSION + "work-order/detail";

      const method = this.mode === "edit" ? "put" : "post";

      this.isLoading = true;
      axios({
        method,
        url,
        data: this.form,
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text:
              res.data?.meta?.message ||
              (this.mode === "edit"
                ? "Data berhasil diperbarui"
                : "Data berhasil disimpan"),
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          });

          this.$emit("close");
          this.$emit("finish");
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Gagal",
            text:
              err.response?.data?.data ||
              err.response?.data?.meta?.message ||
              "Terjadi kesalahan.",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }, // end of store
  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="mode === 'edit' ? 'Edit Peserta' : 'Tambah Peserta'"
    size="lg"
    hide-footer
  >
    <b-form @submit.prevent="store">

      <b-form-group label="Pegawai Internal" class="fw-medium">
        <v-select
          :options="optionPegawaiInternal"
          label="nama"
          :get-option-key="(option) => option.idpegawai_internal"
          v-model="selected.pegawaiInternal"
          placeholder="Cari Pegawai Internal"
          :filterable="false"
          @search="searchPegawaiInternal"
        >
          <template #option="option">{{ option.nama }} - {{ option.u_nip }}</template>
          <template #selected-option="option">{{ option.nama }} - {{ option.u_nip }}</template>
          <template #no-options>Ketik untuk mencari pegawai...</template>
        </v-select>
      </b-form-group>

      <b-form-group label="Nama Profesi Target" class="fw-medium">
        <v-select
          :options="optionProfesi"
          label="nama_profesi"
          :get-option-key="(option) => option.id_mprofesi"
          v-model="selected.profesi"
          placeholder="Cari Profesi"
        >
          <template #option="option">{{ option.nama_profesi }}</template>
          <template #selected-option="option">{{ option.nama_profesi }}</template>
        </v-select>
      </b-form-group>

      <b-form-group label="Jenjang Jabatan" class="fw-medium">
        <v-select
          :options="optionJenjangJabatan"
          label="nama_jenjang"
          :get-option-key="(option) => option.id_jenjang_jabatan"
          v-model="selected.jenjangJabatan"
          placeholder="Cari Jenjang Jabatan"
        >
          <template #option="option">{{ option.nama_jenjang }}</template>
          <template #selected-option="option">{{ option.nama_jenjang }}</template>
        </v-select>
      </b-form-group>

      <b-form-group label="Target PeG" class="fw-medium">
        <v-select
          :options="optionTargetPeg"
          label="target_peg"
          :get-option-key="(option) => option.id_target_peg"
          v-model="selected.targetPeg"
          placeholder="Cari Target PeG"
        >
          <template #option="option">{{ option.target_peg }}</template>
          <template #selected-option="option">{{ option.target_peg }}</template>
        </v-select>
      </b-form-group>

      <b-form-group label="Target Kompetensi" class="fw-medium">
        <v-select
          :options="optionTargetKompetensi"
          label="target_kompetensi"
          :get-option-key="(option) => option.id_target_kompetensi"
          v-model="selected.targetKompetensi"
          placeholder="Cari Target Kompetensi"
        >
          <template #option="option">{{ option.target_kompetensi }}</template>
          <template #selected-option="option">{{ option.target_kompetensi }}</template>
        </v-select>
      </b-form-group>

      <b-form-group label="Level Kompetensi" class="fw-medium">
        <v-select
          :options="optionLevelKompetensi"
          label="nama_level"
          :get-option-key="(option) => option.idlevel_kompetensi"
          v-model="selected.levelKompetensi"
          placeholder="Cari Level Kompetensi"
        >
          <template #option="option">{{ option.nama_level }}</template>
          <template #selected-option="option">{{ option.nama_level }}</template>
        </v-select>
      </b-form-group>

      <div class="text-end mt-3">
        <b-button variant="secondary" class="me-2" @click="$emit('close')">
          Batal
        </b-button>
        <b-button type="submit" variant="primary" :disabled="isLoading">
          <span v-if="isLoading">
            <i class="fa fa-spinner fa-spin me-1"></i> Menyimpan...
          </span>
          <span v-else>Simpan</span>
        </b-button>
      </div>
    </b-form>
  </b-modal>
</template>
